"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fiats = [
    "AED",
    "AMD",
    "AUD",
    "BGN",
    "BRL",
    "CAD",
    "CHF",
    "COP",
    "CZK",
    "DKK",
    "DOP",
    "EUR",
    "GBP",
    "GHS",
    "HKD",
    "HUF",
    "ILS",
    "INR",
    "ISK",
    "JOD",
    "JPY",
    "KRW",
    "KZT",
    "LKR",
    "MXN",
    "NOK",
    "NZD",
    "PEN",
    "PHP",
    "PLN",
    "QAR",
    "RON",
    "SEK",
    "SGD",
    "THB",
    "TRY",
    "TWD",
    "USD",
    "UYU",
    "VND",
    "ZAR",
];
exports.default = fiats;
//# sourceMappingURL=fiats.js.map